<template>
  <div class="box">
    <div class="type1" v-if="type === 1">
      <div class="left">
        <div class="title">
          <div class="icon">{{ num }}</div>
          {{ title }}
        </div>
      </div>
      <div class="right"> <el-button class="button btn1" @click="tiaoguo">跳过</el-button></div>
    </div>
    <div class="type1 type2" v-if="type === 2">
      <div class="left">
        <div class="title">
          <div class="icon">{{ num }}</div>
          {{ title }}
        </div>
      </div>
      <div class="right"></div>
    </div>
    <div class="type1 type3" v-if="type === 3">
      <div class="left">
        <div class="title">
          <div class="icon"><i class="el-icon-check"></i></div>
          {{ title }}
        </div>
        <div class="desc">{{ desc }}</div>
      </div>
      <div class="right">
        <el-button class="button btn1" @click="chakan" v-if="!yitiaoguo">查看</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    type: {
      type: Number,
      default: 1,
    },
  },
  components: {},
  data() {
    return {
      title: "风险排查",
      num: 2,
    };
  },
  created() {},
  computed: {
    ...mapState("fengxian", ["jieguo", "fengxianVisible",'yitiaoguo']),
    desc() {
      return this.jieguo.content;
    },
  },
  methods: {
    ...mapActions("hetongqianshu", ["setStep"]),
    ...mapActions("fengxian", ["setFengxianVisible",'setYitiaoguo']),
    chakan() {
      this.setFengxianVisible(false);
      setTimeout(() => {
        this.setFengxianVisible(true);
      }, 500);
    },
    tiaoguo(){
      this.setYitiaoguo(true)
      this.setStep(4);
    }
  },
};
</script>

<style scoped lang="scss">
@use "~@/views/hetongqianshu/step/shit/index.scss" as *;
</style>
